export default {
  Pending: { status: 'Pending', color: 'orange' },
  Approved: { status: 'Approved', color: 'green' },
  Reject: { status: 'Reject', color: 'red' },
  Hold: { status: 'Hold', color: 'Blue' }
};
